exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".styles__container___3Z1Tx {\n  display: inline-block;\n  border-radius: 3px;\n  background-color: #fff;\n  border: solid 1px #c0c7ce;\n  padding: 0 15px;\n  box-sizing: border-box;\n  min-height: 40px;\n  font-size: 16px;\n  color: #223c61;\n  transition: box-shadow 0.2s, border-color 0.2s;\n}\n.styles__container___3Z1Tx.styles__error___2KemH {\n  background-color: #fffae4;\n  border: solid 1px #ff6848;\n}\n.styles__container___3Z1Tx.styles__block___1-gkO {\n  display: block;\n  width: 100%;\n}\n.styles__container___3Z1Tx:focus {\n  box-shadow: 0 0 0 3px #e8f3ff;\n  border: solid 1px #3199ff;\n}\n.styles__container___3Z1Tx.styles__lower___2qPTk {\n  text-transform: lowercase;\n}\n.styles__container___3Z1Tx:focus,\n.styles__container___3Z1Tx:hover,\n.styles__container___3Z1Tx:active {\n  outline: none;\n}\n.styles__container___3Z1Tx::-webkit-input-placeholder {\n  color: #c0c7ce;\n}\n.styles__container___3Z1Tx::-moz-placeholder {\n  color: #c0c7ce;\n}\n.styles__container___3Z1Tx:-ms-input-placeholder {\n  color: #c0c7ce;\n}\n.styles__container___3Z1Tx:-moz-placeholder {\n  color: #c0c7ce;\n}\n", ""]);

// exports
exports.locals = {
	"container": "styles__container___3Z1Tx",
	"error": "styles__error___2KemH",
	"block": "styles__block___1-gkO",
	"lower": "styles__lower___2qPTk"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./node_modules/stylus-loader!./src/components/shared/Input/styles.styl
// module id = 349
// module chunks = 0